export const streakMilestonesInDays: number[] = [7, 30, 90, 180, 365, 500, 750, 1000, 1250, 1500];
